'use strict';

var updateMiniCart = true;

module.exports = function () {
    $('.minicart').on('count:update', (event, count) => {
        if (count && $.isNumeric(count.quantityTotal)) {
            if (count.quantityTotal <= 99) {
                if (count.quantityTotal == 0) {
                    $('.minicart .minicart-quantity').addClass('visually-hidden').text(count.quantityTotal);
                }
                else {
                    $('.minicart .minicart-quantity').removeClass('visually-hidden').text(count.quantityTotal);
                }
            }
            else {
                $('.minicart .minicart-quantity').removeClass('visually-hidden').text('99+');
            }
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('body').on('change', '.minicart .quantity', event => {
        if ($(event.target).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('body').on('product:afterAddToCart cart:update', () => {
        updateMiniCart = true;
    });
};
